import { Box, VStack } from "@chakra-ui/react";
import { useRouteMatch } from "react-router-dom";

import { RegisterForm } from "modules/authentication/presentation/RegisterForm";

import { ChakraText } from "components/ChakraText";
import { Modal } from "components/Modal";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const RegisterModal = ({ isOpen, onClose }: IProps) => {
  const match = useRouteMatch<{
    appointmentId: string;
  }>({
    path:
      "/e-rezerwacja/:friendlyUrl/:groupId/rezerwacja/:queueId/podsumowanie/:appointmentId",
  });
  const appointmentId = match?.params.appointmentId;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={<ChakraText>Rejestracja</ChakraText>}
      size="xl"
    >
      <VStack spacing={4}>
        <Box w="100%">
          <RegisterForm onCloseModal={onClose} appointmentId={appointmentId} />
        </Box>
      </VStack>
    </Modal>
  );
};

export { RegisterModal };
